export const landing2Routes = [
  {
    path: '/landing2',
    lazy: async () => {
      const { Onboarding } = await import('./Onboarding/Onboarding');
      return { Component: Onboarding };
    },
  },
  {
    path: '/landing2/step1',
    lazy: async () => {
      const { Onboarding } = await import('./Onboarding/Onboarding');
      return { Component: Onboarding };
    },
  },
  {
    path: '/landing2/step2',
    lazy: async () => {
      const { Onboarding } = await import('./Onboarding/Onboarding');
      return { Component: Onboarding };
    },
  },
  {
    path: '/landing2/step3',
    lazy: async () => {
      const { Onboarding } = await import('./Onboarding/Onboarding');
      return { Component: Onboarding };
    },
  },
  {
    path: '/landing2/login',
    lazy: async () => {
      const { LoginRoute } = await import('./Login/Login');
      return { Component: LoginRoute };
    },
  },
  {
    path: '/landing2/register',
    lazy: async () => {
      const { RegisterRoute } = await import('./Register/Register');
      return { Component: RegisterRoute };
    },
  },
  {
    path: '/landing2/forgot-password',
    lazy: async () => {
      const { ForgotPasswordRoute } =
        await import('./ForgotPassword/ForgotPassword');
      return { Component: ForgotPasswordRoute };
    },
  },
];

export const protectedLanding2Routes = [
  {
    path: '/landing2/plan',
    lazy: async () => {
      const { PlanRoute } = await import('./Plan/Plan');
      return { Component: PlanRoute };
    },
  },
];
